import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { PageLoaderService } from '../services';

@Injectable()
export class PageLoaderInterceptor implements HttpInterceptor {
  constructor(private readonly pageLoaderService: PageLoaderService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // Show loader when request starts
    this.pageLoaderService.show();

    return next.handle(request).pipe(
      tap({
        next: (event: HttpEvent<unknown>) => {
          // Optional: Handle successful responses here if needed
          if (event instanceof HttpResponse) {
            // Request completed successfully
          }
        },
        error: (error: HttpErrorResponse) => {
          // Handle errors here if needed
          console.error('HTTP Error:', error);
        },
      }),
      finalize(() => {
        // Hide loader when request completes (success or error)
        this.pageLoaderService.hide();
      }),
    );
  }
}